class VVSeoBlock extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('[data-vv-seo-body]');
    this.toggle = this.querySelector('[data-vv-seo-toggle]');
    if (!this.body || !this.toggle) return;

    // Hide the toggle when the body isn't tall enough to need truncating.
    if (this.body.scrollHeight <= this.body.clientHeight + 2) {
      this.body.classList.remove('is-truncated');
      this.toggle.hidden = true;
      return;
    }

    this.toggle.addEventListener('click', () => {
      const truncated = this.body.classList.toggle('is-truncated');
      this.toggle.textContent = truncated ? this.toggle.dataset.more : this.toggle.dataset.less;
      this.toggle.setAttribute('aria-expanded', String(!truncated));
    });
  }
}

customElements.define('vv-seo-block', VVSeoBlock);
